import styled from 'styled-components';

export const LayoutFixedWidthWrapper = styled.div`
  max-width: 1000px;
  width: 100%;
`;
